import { render, staticRenderFns } from "./blockDisplay.vue?vue&type=template&id=41baa829&scoped=true"
import script from "./blockDisplay.vue?vue&type=script&lang=js"
export * from "./blockDisplay.vue?vue&type=script&lang=js"
import style0 from "./blockDisplay.vue?vue&type=style&index=0&id=41baa829&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41baa829",
  null
  
)

export default component.exports